<template>
  <div>
    <MobialisFormWithValidation @onValidate="getResult" v-av-analytics-form-submit="{ elementText: btnText }">
      <div :class="{ 'row justify-content-between': showBlocks }">
        <div :class="{ 'col-sm-7': showBlocks }">
          <ConfirmIDHero v-if="isAVRDesktop || isAVREmbed"></ConfirmIDHero>
          <div v-for="(question, index) in questions" :key="index">
            <h5 class="pb-2 my-3">{{ question }}</h5>
            <MobialisFancyRadio
              :data-av-analytics-element-text-value="`Answer ${index + 1}`"
              class="pb-2"
              :textArray="choices[index]"
              :name="`Answer ${index + 1}`"
              v-model="answersArray[index]"
            ></MobialisFancyRadio>
          </div>
        </div>
        <div v-if="showBlocks" class="col-sm-4 d-none d-sm-block">
          <DisclaimerCard
            class="card border-0 shadow mb-2"
            :iconSrc="require('@/assets/shield-check.svg')"
            :title="$t('message.credit.confirmIdCardTitle')"
            :text="confirmIdCardText"
            :text-left-space="false"
          ></DisclaimerCard>
        </div>
      </div>
      <MobialisButton class="mt-4 mb-1" type="submit" data-cy="confirmId">
        {{ btnText }}
      </MobialisButton>
      <p class="d-flex justify-content-center small my-0 text-center">
        {{ $t('message.credit.disclaimer.noAffectScore') }}
      </p>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmIDHero from '@/components/credit/hero/ConfirmID.vue';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import log from '@/services/log';
import helperFunctions from '@/utils/helperFunctions';

export default {
  name: 'ConfirmID',
  beforeRouteEnter: helperFunctions.onlyAcceptRoutes(['form-review']),
  data() {
    return {
      questions: [],
      choices: [],
      answersArray: [],
    };
  },
  components: {
    ConfirmIDHero,
    DisclaimerCard,
  },
  computed: {
    ...mapGetters('business', [
      'getThisIsAmerica',
      'isPrequalificationEnabled',
      'isKijijiDealer',
      'prequalificationTradeInEquityAssessmentEnabled',
      'prequalificationIncomeAndDebtEnabled',
      'displayEquifaxBranding',
    ]),
    confirmIdCardText() {
      if (this.displayEquifaxBranding) {
        return this.$t('message.credit.confirmIdEquifaxCardText');
      }
      return this.$t('message.credit.confirmIdCardText');
    },
    btnText() {
      if (this.prequalificationTradeInEquityAssessmentEnabled || this.prequalificationIncomeAndDebtEnabled) {
        return this.$t('message.common.continue');
      }
      if (this.isPrequalificationEnabled) {
        return this.$t('message.credit.viewAutoAffordability');
      }
      return this.$t('message.credit.getCreditScore');
    },
  },
  methods: {
    async getResult(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('credit/getCreditScore', this.answersArray);
      } catch (err) {
        // we only log when it's an actual error from the server or kijiji for debugging
        if ((err.response && err.response.status === 500) || this.isKijijiDealer) {
          log('Error in Credit ConfirmId, RCC failed', err);
        }
      } finally {
        // We update the lead info whether it succeed or not
        await this.updateLead();
      }
    },
    async updateLead() {
      try {
        await this.$store.dispatch('lead/updateLead');
        if (this.prequalificationIncomeAndDebtEnabled) {
          this.$router.push({
            name: `income-and-mortgage-${this.baseRoute}`,
          });
        } else if (this.prequalificationTradeInEquityAssessmentEnabled) {
          this.$router.push({
            name: `credit-carfax-trade-in-${this.baseRoute}`,
          });
        } else {
          this.$router.push({
            name: `credit-results-${this.baseRoute}`,
          });
        }
      } catch (err) {
        log('Error in Credit ConfirmId - Update Lead', err);
        this.$router.push({
          name: `credit-in-error-${this.baseRoute}`,
        });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
  created() {
    this.questions = this.$store.state.credit.questionData.questions;
    this.choices = this.$store.state.credit.questionData.choices;
    this.answersArray = this.$store.state.credit.questionData.userAnswers;
  },
};
</script>

<style lang="scss" scoped>
h5 {
  font-size: 16px;
  font-weight: bold;
}
</style>
